module.exports = __webpack_public_path__ + "img/mobiletalent.6c80745.png";